import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setRouteEditOptionsModal } from "../../../reducers/ownApp";
import { processRouteEditAction } from "../../../reducers/matrixProfile/thunkActions";

import { RouteEditOptionsModalContent } from "./RouteEditOptionsModalContent";
import { RouteEditOptionsModalActions } from "./RouteEditOptionsModalActions";
import {
  routeEditOptionsModalOpenSelector,
  routeEditOptionsModalMessage,
  routeEditOptionsModalOptionsSelector,
} from "../../../reducers/ownApp/selectors";

import { Modal } from "../Modal";

const RouteEditOptionsModal = () => {
  const dispatch = useDispatch();
  const open = useSelector(routeEditOptionsModalOpenSelector);
  const message = useSelector(routeEditOptionsModalMessage);
  const options = useSelector(routeEditOptionsModalOptionsSelector);
  const [selectedOption, setSelectedOption] = useState();

  useEffect(() => {
    options?.length && setSelectedOption(options[0]);
  }, [options]);

  const closeClick = () => {
    dispatch(setRouteEditOptionsModal({ open: false }));
  };

  const confirmClick = () => {
    dispatch(setRouteEditOptionsModal({ open: false }));
    dispatch(processRouteEditAction({ change: selectedOption }));
  };

  return (
    <>
      <Modal
        maxWidth={"xs"}
        open={open}
        onClose={closeClick}
        title={"Warning"}
        content={
          <RouteEditOptionsModalContent
            message={message}
            options={options}
            selectedOption={selectedOption}
            onOptionChange={(option) => {
              setSelectedOption(option);
            }}
          />
        }
        actions={
          <RouteEditOptionsModalActions
            onCancel={closeClick}
            onContinue={confirmClick}
          />
        }
        minWidth={500}
      />
    </>
  );
};

export default RouteEditOptionsModal;
